// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"8007":"33b41c7d8daa21cf","8579":"41601e6a8d884eb2"}[chunkId] + ".js";
};